<template>
	<el-tabs :value="value.name" @tab-click="changeTab" :key="tabsChangedKey">
		<el-tab-pane v-for="tab in elements" :name="tab.name" :key="tab.name"
					 :disabled="!hasAccess(tab)"
		>
			<el-tooltip slot="label" popper-class="tooltip-md" placement="bottom"
						:disabled="hasAccess(tab)"
						:open-delay="500"
			>
				<span slot="content" v-html="accessDeniedTooltip(tab)"></span>
				<span>
					<i v-if="!hasAccess(tab)" class="fa fa-lock"></i>
					{{$t(tab.translationKey) + (tab.count != null && tab.count >= 0 ? ' (' + tab.count + ')' : '')}}
				</span>
			</el-tooltip>
			<slot/>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import AccessRestrictedBaseComponentGroup
	from "@/components/templates/common/permissions/AccessRestrictedBaseComponentGroup";

export default {
	extends: AccessRestrictedBaseComponentGroup,
	data() {
		return {
			tabsChangedKey: 0
		};
	},
	methods: {
		changeTab(tab) {
			for (let elementKey in this.elements) {
				if (this.elements[elementKey].name === tab.name) {
					this.activateElement(this.elements[elementKey])
					break;
				}
			}
		},
	},
	watch: {
		elements: {
			handler() {
				this.tabsChangedKey++;
			},
			deep: true
		}
	}
};
</script>